import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider, } from "react-router-dom";
import './index.css';
import reportWebVitals from './reportWebVitals.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import Root from './components/routes/root/root';
import LandingPage from './components/landing_page/LandingPage'; 
import Portfolio from './components/portfolio/Portfolio';
import Socials from './components/socials/Socials';
import ErrorPage from './components/ErrorPage';
import Shop from './components/shop/Shop'
import Commissions from './components/commissions/Commissions'
import { EditorRoot } from './components/routes/editor/editor'; 
import KofiProductsEditor from './components/routes/editor/KofiProductsEditor'

/**  TODO: see if some of these fontsource files can be omitted, 
 *  (The documentation recommends only importing the specific styles needed in order to reduce bundle size)
 *  see https://fontsource.org/docs/getting-started/install */
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: <LandingPage />,
      },
      {
        path: "portfolio",
        element: <Portfolio />,
      },
      // {
      //   path: "portfolio/:category_path",
      //   element: <PortfolioCategory />
      // }, 
      {
        path: "socials",
        element: <Socials />
      }, 
      { 
        path: "shop",
        element: <Shop />
      }, 
      { 
        path: "commissions",
        element: <Commissions />
      }
    ]
  }, 
  { 
    path: "/editor",
    element: <EditorRoot />,
    errorElement: <ErrorPage/>,
    children: [
      {
        path: "",
        element: <KofiProductsEditor />
      }
    ]
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
